<template lang="html">
  <div class="coupon-list-empty">
    <p><img src="../../assets/images/no-coupon-icon.png" alt="" /></p>
    <p>暂无优惠券</p>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.coupon-list-empty {
  padding-top: rem(200px);
  text-align: center;

  img {
    width: rem(300px);
  }
  p {
    margin-top: rem(20px);
    color: #999;
  }
}
</style>
